import React from "react";
import "./App.css";
import { HashRouter , Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import LandingPage from "./components/LandingPage";
import XMLDownload from "./components/XMLDownload";
import HelpPage from "./components/HelpPage";
import TermoUso from "./components/TermoUso";

function App() {
  return (
    <div className="App">
      <HashRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/xml" element={<XMLDownload />} />
          <Route path="/ajuda" element={<HelpPage />} />
          <Route path="/termouso" element={<TermoUso />} />
        </Routes>
        <Toaster position="top-right" />
      </HashRouter>
    </div>
  );
}

export default App;